import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoModule } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export interface PrijemniFormularData {
  initialNotes: string | null;
  prevTreated: boolean | null;
  prevVetNotes: string | null;
  vaccineRabies: string | null;
  vaccineInfectious: string | null;
  externalParasites: string | null;
  internalParasites: string | null;
  heardFrom: string | null;
  note: string | null;
  veterinarianName: string | null;
}

@Component({
  selector: 'anihis-prijemni-formular',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    TranslocoModule,
  ],
  templateUrl: './prijemni-formular.component.html',
  styleUrls: ['./prijemni-formular.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrijemniFormularComponent implements OnInit {
  @Output() formChange = new EventEmitter<PrijemniFormularData>();

  private readonly fb = inject(FormBuilder);
  private readonly destroyRef = inject(DestroyRef);

  form!: FormGroup;

  ngOnInit(): void {
    this.form = this.fb.group({
      initialNotes: [''],
      prevTreated: [null],
      prevVetNotes: [''],
      vaccineRabies: [''],
      vaccineInfectious: [''],
      externalParasites: [''],
      internalParasites: [''],
      heardFrom: [''],
      note: [''],
      veterinarianName: [''],
    });

    this.form.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        this.formChange.emit(value);
      });
  }

  get f() {
    return this.form.controls;
  }
}
